export default __webpack_public_path__ + "d197baa581062dcfc47a17d9ca7b98d4.png";